import {FaEnvelope,FaShieldAlt,FaCookie} from 'react-icons/fa';
import {useLanguage} from '../context/LanguageContext';
import {useState} from 'react';
import {Link} from 'react-router-dom';
import CookiePreferences from './CookiePreferences';

const Footer=()=> {
  const {t}=useLanguage();
  const [showPrivacyModal,setShowPrivacyModal]=useState(false);
  const [showCookieModal,setShowCookieModal]=useState(false);
  const [showCookiePreferences,setShowCookiePreferences]=useState(false);

  const PrivacyModal=()=> {
    if (!showPrivacyModal) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 overflow-y-auto">
        <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-4 border-b">
            <h2 className="text-xl font-bold text-gray-900">Privacy Policy</h2>
            <button
              onClick={()=> setShowPrivacyModal(false)}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors"
            >
              ✕
            </button>
          </div>
          <div className="p-6">
            <div className="prose prose-sm max-w-none">
              <h3>Data Controller:</h3>
              <p>ISTITUTO VENETO DI TERAPIA FAMILARE srl,C.F. and P.IVA 02034280269,Via Della Quercia 2/B,31100 Treviso (TV)</p>
              <p>Data Controller email address: segreteria@itfv.it</p>
              <h3>Purposes of the Processing of Collected Data</h3>
              <p>The User Data is collected to allow the Owner to provide its Service,comply with legal obligations,respond to requests or enforcement actions,protect its rights and interests (or those of its Users or third parties),identify any malicious or fraudulent activity,as well as the following: Tag Management,Analytics,Contacting the User and Displaying content from external platforms.</p>
              <p>To obtain detailed information on the purposes of the processing and on the Personal Data processed for each purpose,the User may refer to the section "Detailed information on the processing of Personal Data".</p>
              <h3>Types of Data collected</h3>
              <p>Among the types of Personal Data that this Application collects,by itself or through third parties,there are: Tracker;Usage Data;language;device information;first name;last name;email address;number of Users;session statistics.</p>
              <p>Complete details on each type of Personal Data collected are provided in the dedicated sections of this privacy policy or by specific information texts displayed before the Data are collected. Personal Data may be freely provided by the User,or,in the case of Usage Data,collected automatically when using this Application. Unless otherwise specified,all Data requested by this Application is mandatory. Failure to provide this Data may make it impossible for this Application to provide its Service. In cases where this Application specifically states that some Data is optional,Users are free not to communicate this Data without any consequences on the availability or operation of the Service. Users who are uncertain about which Data is mandatory are encouraged to contact the Owner. Any use of Cookies - or other tracking tools - by this Application or by the owners of third-party services used by this Application is intended to provide the Service requested by the User,in addition to the other purposes described in this document and in the Cookie Policy.</p>
              <p>The User assumes responsibility for the Personal Data of third parties obtained,published or shared through this Application.</p>
              {/* Resto del contenuto Privacy Policy rimane uguale */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const CookieModal=()=> {
    if (!showCookieModal) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4 overflow-y-auto">
        <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-4 border-b">
            <h2 className="text-xl font-bold text-gray-900">Cookie Policy</h2>
            <button
              onClick={()=> setShowCookieModal(false)}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors"
            >
              ✕
            </button>
          </div>
          <div className="p-6">
            <div className="prose prose-sm max-w-none">
              {/* Resto del contenuto Cookie Policy rimane uguale */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <footer className="bg-gray-800 text-white py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Contatti con mascotte */}
            <div>
              <h3 className="text-lg font-bold mb-3 flex items-center">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1750973984906-Mascotte_testa_1_to_1.png"
                  alt="COSMO Personality Logo"
                  className="h-5 w-5 rounded-full mr-2"
                />
                {t('contactUs')}
              </h3>
              <div className="flex items-center space-x-2 text-gray-300">
                <FaEnvelope className="text-sm" />
                <span className="text-sm">info@cosmopersonality.com</span>
              </div>
            </div>

            {/* Navigation e Legal */}
            <div className="grid grid-cols-2 gap-4">
              {/* Navigation Links */}
              <div>
                <h3 className="text-lg font-bold mb-3">Navigation</h3>
                <ul className="space-y-1 text-gray-300">
                  <li><a href="#/about" className="text-sm hover:text-white transition-colors">{t('about')}</a></li>
                  <li><a href="#/contact" className="text-sm hover:text-white transition-colors">{t('contact')}</a></li>
                  <li><Link to="/schools" className="text-sm hover:text-white transition-colors">Schools</Link></li>
                </ul>
              </div>

              {/* Legal Links */}
              <div>
                <h3 className="text-lg font-bold mb-3">Legal</h3>
                <ul className="space-y-1 text-gray-300">
                  <li>
                    <button
                      onClick={()=> setShowPrivacyModal(true)}
                      className="flex items-center text-sm hover:text-white transition-colors"
                    >
                      <FaShieldAlt className="mr-1 text-xs" />
                      Privacy Policy
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={()=> setShowCookieModal(true)}
                      className="flex items-center text-sm hover:text-white transition-colors"
                    >
                      <FaShieldAlt className="mr-1 text-xs" />
                      Cookie Policy
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={()=> setShowCookiePreferences(true)}
                      className="flex items-center text-sm hover:text-white transition-colors"
                    >
                      <FaCookie className="mr-1 text-xs" />
                      Manage Cookies
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-6 pt-4 border-t border-gray-700 text-center text-gray-300">
            <p className="text-sm">&copy;{new Date().getFullYear()} COSMO Personality. {t('allRightsReserved')}</p>
          </div>
        </div>
      </footer>

      {/* Modals esistenti */}
      <PrivacyModal />
      <CookieModal />

      {/* Modal per gestione preferenze cookie */}
      <CookiePreferences
        isOpen={showCookiePreferences}
        onClose={()=> setShowCookiePreferences(false)}
      />
    </>
  );
};

export default Footer;